import CnpjUtils from "../../shared/utils/CnpjUtils";

export async function getPromocoesMarcaPropria(idPedido, cnpjLab) {
	try {
		const apiUrl =
			process.env.REACT_APP_ESSILOR_API +
			`gestao-promocao-laboratorio/v1/promocoes?idPedido=${encodeURIComponent(idPedido)}`;

		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"access_token": sessionStorage.getItem("token"),
				"client_id": localStorage.getItem("clientid"),
				"grant_token": sessionStorage.getItem("grant_token"),
				"laboratorio": CnpjUtils.cleanCnpj(cnpjLab),
			},
		};

		const response = await fetch(apiUrl, requestOptions);

		if (response.status !== 200) {
			return [];
		}

		const data = await response.json();

		return data.promocoes || [];
	} catch (error) {
		return [];
	}
}
